import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {FileService} from 'src/app/services/file.service';
import MyEditor from 'ckeditor5-custom-build/build/ckeditor';

@Component({
  selector: 'app-new-forum',
  templateUrl: './new-forum.component.html',
  styleUrls: ['./new-forum.component.scss']
})
export class NewForumComponent implements OnInit {
  private params: Params;
  datasetId = 0;
  dataset: any = false;
  isReady = false;
  inProgress = false;
  devMode = false;
  subject: string = null;
  description: string = null;
  public Editor = MyEditor;
  enterpriseUser = null;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private trustiiService: TrustiiService,
              private dataservice: DataService,
              private sessionService: SessionService,
              public fileService: FileService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.datasetBannerModel.setBannerView(DatasetBannerView.ForumView);

    this._loadParams$()
      .pipe(
        switchMap(this._loadDataset$.bind(this)),
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.params
      .pipe(
        map((params: Params) => this.params = params)
      );
  }

  /** _loadDataset$ method
   *
   * Load dataset if there is id dataset on params.
   */
  private _loadDataset$(): Observable<any> {
    if (!this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;

    return this.trustiiService.getDataset(this.datasetId)
      .pipe(
        map((dataset: any) => {
            this.dataset = dataset.data;
            this.isReady = true;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
  }

  /**
   * Save topic
   */
  save(): void {
    this.inProgress = true;
    const payload = {
      subject: this.subject,
      description: this.description,
    };

    this.trustiiService.postForum(this.datasetId, payload).subscribe(
      (res) => {
        this.inProgress = false;
        this.router.navigateByUrl('/datasets/' + this.datasetId + '/forums', {skipLocationChange: true});
      }, (err) => {
        this.inProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          'Failed to add a new topic',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }
}
